import { Role } from 'enum/roles';
import { useRouter } from 'next/router';
import { Routes } from 'services/routes';
import { useProfile } from './useProfile';
import { RoleMap } from './useGetRole';

export const useRequireRole = (requiredRole: Role): void => {
  const { profile, loading } = useProfile();
  const router = useRouter();

  if (loading) return;

  if (!profile) {
    void router.push(Routes.logIn(router.asPath));
    return;
  }

  const { role } = profile;

  if (role.includes(RoleMap.master)) return;

  if (role.includes(RoleMap['executive-admin']) && requiredRole !== 'master') return;

  if (role.includes(RoleMap.admin) && !['master', 'executive-admin'].includes(requiredRole))
    return;

  if (
    role.includes(RoleMap.leader) &&
    !['master', 'executive-admin', 'admin'].includes(requiredRole)
  )
    return;

  if (!['master', 'executive-admin', 'admin', 'leader'].includes(requiredRole))
    return;

  void router.push(Routes.logIn());
};
